import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Field, inputCls } from "./shared";

const PRICES = ["", "250000", "500000", "750000", "1000000", "1500000", "2000000"];
const BEDS = ["", "1", "2", "3", "4", "5"];

const SearchPanel = ({ testIdPrefix = "search" }) => {
  const navigate = useNavigate();
  const [loc, setLoc] = useState("");
  const [min, setMin] = useState("");
  const [max, setMax] = useState("");
  const [beds, setBeds] = useState("");

  const go = (e) => {
    e.preventDefault();
    const p = new URLSearchParams({ tab: "newest" });
    if (loc.trim()) p.set("q", loc.trim());
    if (min) p.set("min", min);
    if (max) p.set("max", max);
    if (beds) p.set("beds", beds);
    navigate(`/listings?${p.toString()}`);
  };

  return (
    <form onSubmit={go} data-testid={`${testIdPrefix}-form`}>
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <Field label="Location" htmlFor={`${testIdPrefix}-location`}>
          <input
            id={`${testIdPrefix}-location`}
            value={loc}
            onChange={(e) => setLoc(e.target.value)}
            className={inputCls}
            placeholder="City, neighborhood, or ZIP"
            data-testid={`${testIdPrefix}-location-input`}
          />
        </Field>
        <Field label="Min Price" htmlFor={`${testIdPrefix}-min`}>
          <select id={`${testIdPrefix}-min`} value={min} onChange={(e) => setMin(e.target.value)} className={inputCls} data-testid={`${testIdPrefix}-min-select`}>
            {PRICES.map((v) => (
              <option key={v} value={v}>{v ? `$${Number(v).toLocaleString()}` : "No Min"}</option>
            ))}
          </select>
        </Field>
        <Field label="Max Price" htmlFor={`${testIdPrefix}-max`}>
          <select id={`${testIdPrefix}-max`} value={max} onChange={(e) => setMax(e.target.value)} className={inputCls} data-testid={`${testIdPrefix}-max-select`}>
            {PRICES.map((v) => (
              <option key={v} value={v}>{v ? `$${Number(v).toLocaleString()}` : "No Max"}</option>
            ))}
          </select>
        </Field>
        <Field label="Bedrooms" htmlFor={`${testIdPrefix}-beds`}>
          <select id={`${testIdPrefix}-beds`} value={beds} onChange={(e) => setBeds(e.target.value)} className={inputCls} data-testid={`${testIdPrefix}-beds-select`}>
            {BEDS.map((v) => (
              <option key={v} value={v}>{v ? `${v}+` : "Any"}</option>
            ))}
          </select>
        </Field>
      </div>
      <div className="mt-7 flex flex-col gap-4 sm:flex-row sm:items-center">
        <button
          type="submit"
          data-testid={`${testIdPrefix}-submit-button`}
          className="inline-flex items-center justify-center gap-3 bg-charcoal px-8 py-4 font-mono text-[11px] uppercase tracking-[0.3em] text-ivory transition-colors duration-500 hover:bg-champagne hover:text-obsidian"
        >
          <Search size={13} strokeWidth={1.5} aria-hidden="true" />
          Search Listings
        </button>
        <p className="text-xs leading-relaxed text-slate-muted">
          Searching the live portfolio. For full-MLS access and off-market opportunities,{" "}
          <a href="tel:+12403724804" className="link-underline text-charcoal" data-testid={`${testIdPrefix}-call-link`}>call 240-372-4804</a>.
        </p>
      </div>
    </form>
  );
};

export default SearchPanel;
